import { render, staticRenderFns } from "./TransactionChangeHistory.vue?vue&type=template&id=3b42ac16"
import script from "./TransactionChangeHistory.vue?vue&type=script&lang=js"
export * from "./TransactionChangeHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports